












import {Component, Vue, Watch} from 'vue-property-decorator';
import FacebookPixelForm from '@/screens/dashboard/facebookpixel/FacebookPixelForm.vue';
import {IFacebookPixel} from '@/models/IFacebookPixel';
import {getFacebookPixelById} from '@/services/FacebookPixelService';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    FacebookPixelForm
  }
})
export default class EditFacebookPixelScreen extends Vue {
  facebookPixel: IFacebookPixel | null = null;
  loading: boolean = true;

  get facebookPixelId() {
    return this.$route.params.id;
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.facebookPixel = await getFacebookPixelById(this.organizationId, this.shopId, this.facebookPixelId);
    } finally {
      this.loading = false;
    }
  }
}
